import './notfound.scss';
// eslint-disable-next-line no-unused-vars
import { createElement, Fragment } from './incdom';
// TODO: Fix list of pages for mobile
var notFoundPage = function (image, siteMap) {
    return ({
        content: [
            {
                pageLocation: 'notfound',
                image: { imageName: image, title: 'Page Not Found' },
                pageTitle: 'Not Found',
                index: false,
                name: 'notfound',
                content: createElement(Fragment, null,
                    createElement("h2", { class: 'page-title' }, "Page Not Found"),
                    createElement("p", null, "The page you were trying to find:"),
                    createElement("p", { style: 'padding-left: 50px' }, window.location.pathname),
                    createElement("p", null, "does not exist. Please choose a page from the links below:"),
                    siteMap)
            }
        ],
        subMenu: []
    });
};
export { notFoundPage };
//# sourceMappingURL=notfound.js.map